import map from 'lodash/map';
import React, { Component } from 'react';
import { connect } from '~/redux/connect';
import AppBar from '~/ui/AppBar/AppBar.js';
import { getCurrentModelId, getAuthResult, getLoadedModels, getModelName, isDataModelLoaded, isDataModelValid } from "~/stateGetter";
import PageContainer from "~/ui/PageContainer/PageContainer";
import NavigationConfirmDialog from "~/ui/NavigationConfirmDialog/NavigationConfirmDialog";
import ModelConfigCache from "~/ui/ModelDataManager/ModConfigCache";
import getConfig from "~/config"
import DialogContainer from '~/ui/DialogContainer/DialogContainer';
import { ThemeProvider as NativeBaseProvider, ScrollView } from  "~/native-ui"
import { AppWrapper } from "./AppWrapper";
import { Drawer } from "../Drawer"
import { ThemeStateGetter } from '../../StateGetters/ThemeStateGetter';


class MainAppView extends Component {
    static propTypes = {};

    componentDidMount = () => {

    };

    render() {
        return (
            <NativeBaseProvider themeColor={ this.props.themeColor }>
                <AppWrapper>
                    <NavigationConfirmDialog />

                    {getConfig().cacheModels ? <ModelConfigCache /> : null}

                    <Drawer
                        showDrawer={ this.props.auth }
                        appBar={
                            <AppBar />
                        }

                        body={
                            <PageContainer />
                        }
                    />

                        <DialogContainer />
                </AppWrapper>
            </NativeBaseProvider>
        );
    }
}

const MainApp = connect((state) => {
    return {
        modelId: getCurrentModelId(state),
        auth: !!getAuthResult(state).value,
        themeColor: new ThemeStateGetter(state).getThemeColor()
    };
})(MainAppView);

export default MainApp;